<p-fieldset [legend]="title" class="grid">
  <div class="formgroup-inline">
    <ng-content></ng-content>
  </div>
</p-fieldset>
